import React, { useEffect, useState } from "react";
import { Container, Label, Input, FormGroup } from "reactstrap";
import "../../../share/form.css";
// import { BsUpload } from "react-icons/bs";
import { Formik, Field, Form} from "formik";
import * as Yup from "yup";
import { useNavigate, useSearchParams } from "react-router-dom";
// import { Loading } from "../../../share/loading";
import Swal from "sweetalert2";

export function DetailAndAllocateForSkillDevelopmentComponent() {
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const [data, setData] = useState([]);
    // const [datasupportDetails, setsupportDetailsData] = useState([]);
    // const [dataclassDetails, setclassDetailsData] = useState([]);
    // const user = JSON.parse(localStorage.getItem("userData"));
    const [searchParams] = useSearchParams();
    let supportId = searchParams.get("req");


    useEffect(() => {
        getCheckBorrow();
    }, []);

    async function getCheckBorrow() {
        setLoading(true);
        let postData = new FormData();
        postData.append("supportId", supportId);
        try {
            let res = await fetch("/api/Support/getsupportData", {
                method: "POST",
                body: postData,
            });
            const data = await res.json();
            // console.log(data.dataenum);
            setData(data.dataenum);

        } catch (e) {
            // console.log("err =>" + e);
        } finally {
            setLoading(false);
        }
    }

    const initialValues = {
        transferDate: "",
        transferAmount: "",
        Slipfile: "",
        TransferStatus: "1",
        supportId: supportId,
    };

    const validateSchema = Yup.object().shape({
        transferDate: Yup.string().required("กรุณาเลือกวันที่โอนเงิน"),
        transferAmount: Yup.string().required("กรุณากรอกจำนวนเงินที่โอน"),

    });

    const onSubmit = async (
        values,
        { setFieldValue, setFieldError, setFieldTouched },
        actions
    ) => {
        // console.log("values", values)
        let postData = new FormData();
        Object.entries(values).forEach(([key, value]) => {
            postData.append(key, value);
        });
        try {
            let res = await fetch("/api/Support/saveTransfersubmit", {
                method: "POST",
                body: postData,
            });

            let resJson = await res.json();
            // console.log(resJson.dataenum);

            if (resJson.status === 1) {
                Swal.fire({
                    icon: "success",
                    title: "อัพเดทข้อมูลสำเร็จ",
                    text: "บันทึกข้อมูลต่อหรือไม่?",
                    confirmButtonColor: "#0A66C2",
                    confirmButtonText: "ตกลง",
                }).then((result) => {
                    if (result.isConfirmed) {
                        values.train === true ? navigate(`/supporting/`)
                            : navigate(`/supporting/`);
                    }
                });
            } else {
                Swal.fire({
                    icon: "error",
                    title: "อัพเดทข้อมูลไม่สำเร็จ",
                    text: `เนื่องจาก ${resJson.message}`,
                    confirmButtonColor: "#0A66C2",
                    confirmButtonText: "ตกลง",
                });
            }
        } catch (e) {
            // console.log("err =>", e)
        }
    };
    return (

        <Container className="d-flex justify-content-center align-items-center mt-2 mb-4 tab-container">
            <Formik
                initialValues={initialValues}
                validationSchema={validateSchema}
                onSubmit={onSubmit}
                enableReinitialize
            >
                {({ values, handleChange, handleBlur, setFieldValue, setValues, errors, touched }) => {
                    return (
                        <div className="form-border">
                            <Form className="p-5 mb-4">
                                <div className="mt-3 d-flex align-items-center justify-content-center">
                                    <Label
                                        style={{ fontWeight: "bold" }}
                                        className="customer-type text-center px-5"
                                    >
                                        แบบฟอร์มบันทึกข้อมูลรายละเอียดการจัดสรรเงินช่วยเหลือหรืออุดหนุน

                                    </Label>
                                </div>
                                <div className="mt-3 d-flex align-items-center justify-content-center">
                                    <span style={{ fontWeight: "bold" }} className="customer-type text-center px-5">ประจำปีงบประมาณ</span>
                                    <p type="select" className="w-25 rounded-pill border p-1 text-center input-color">
                                        {data != null && data.length > 0 ? (
                                            data[0]?.budgetYear
                                        ) : (
                                            null
                                        )}

                                    </p>
                                </div>
                                <div className="mt-3 d-flex align-items-center justify-content-between">
                                    <span>
                                        หน่วยงาน<span>*</span>
                                    </span>
                                    <p type="select" className="w-75 rounded-pill border p-1 text-center input-color">
                                        {data != null && data.length > 0 ? (
                                            data[0]?.site
                                        ) : (
                                            null
                                        )}
                                        
                                    </p>
                                </div>
                                <div className="mt-3 d-flex align-items-center justify-content-between">
                                    <span>
                                        จัดสรรเงินช่วยเหลือหรืออุดหนุนตามประกาศ
                                    </span>
                                    <p className="w-50 p-2 rounded-pill text-center input-color border text-light bg-secondary">
                                    กรมพัฒนาฝีมือแรงงาน
                                    </p>
                                </div>
                                <FormGroup className="mt-3  d-flex align-items-center justify-content-between">

                                    <span >จำนวนเงินที่โอน</span>
                                    <Field name={`transferAmount`}>

                                        {({ field, meta }) => (
                                            <Input
                                                className={
                                                    meta.error && meta.touched
                                                        ? "input-error rounded-pill text-center input-color w-25"
                                                        : "rounded-pill text-center input-color w-25"
                                                }
                                                {...field}
                                            />
                                        )}
                                    </Field>
                                    <span>บาท</span>
                                    <span>วัน/เดือน/ปี ที่โอน</span>
                                    <Field name={`transferDate`}>

                                        {({ field, meta }) => (
                                            <Input
                                                type="date"
                                                className={
                                                    meta.error && meta.touched
                                                        ? "input-error rounded-pill text-center input-color w-25"
                                                        : "rounded-pill text-center input-color w-25"
                                                }
                                                {...field}

                                            />
                                        )}
                                    </Field>
                                </FormGroup>
                                <FormGroup className="mt-3 d-flex align-items-start justify-content-center flex-column ">
                                    <span className="">เอกสารอื่นๆ(ถ้ามี)</span>
                                    <Input
                                        name="Slipfile"
                                        type="file"
                                        className="mt-2 rounded-pill text-center input-color w-100"


                                        onBlur={handleBlur}
                                        onChange={(e) => {
                                            handleChange(e)
                                            if (e.target && e.target.files[0]) {
                                                setFieldValue(`Slipfile`, e.target.files[0]);
                                            }
                                        }}
                                    />

                                </FormGroup>
                                <div className="mt-3 d-flex align-items-center justify-content-center flex-column ">
                                    <button type="submit" className="p-1 bg-primary rounded-pill w-25 text-white border-0">บันทึก</button>
                                </div>
                            </Form>
                        </div>
                    )
                }}
            </Formik>
        </Container>
    )
}